import { render } from "./historyMobile.vue?vue&type=template&id=1816cb58&scoped=true"
import script from "./historyMobile.vue?vue&type=script&scoped=true&lang=js"
export * from "./historyMobile.vue?vue&type=script&scoped=true&lang=js"

import "./historyMobile.vue?vue&type=style&index=0&id=1816cb58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1816cb58"]])

export default __exports__